"use client";

import { createContext, useContext } from "react";
import {
  DEFAULT_BRAND_LOGO_VARIANT,
  type BrandLogoVariantId,
} from "@/lib/brand/logo-variant";

const BrandLogoContext = createContext<BrandLogoVariantId>(
  DEFAULT_BRAND_LOGO_VARIANT,
);

export function BrandLogoProvider({
  variant,
  children,
}: {
  variant: BrandLogoVariantId;
  children: React.ReactNode;
}) {
  return (
    <BrandLogoContext.Provider value={variant}>
      {children}
    </BrandLogoContext.Provider>
  );
}

export function useBrandLogoVariant(): BrandLogoVariantId {
  return useContext(BrandLogoContext);
}
